import { Route, Switch, withRouter } from 'react-router'

//ramda

//utils
import { ROUTES } from './module/constants'

//components

//pages
import Login from './pages/Login'
import Main from './App/index'

//messages and tranlations

//styles and scss
import classes from './App.module.scss'

//containers
import ProtectedRoute, {
  IPrivateRouteProps,
} from './containers/ProtectedRoute/ProtectedRoute'

function App() {
  const IPrivateRouteProps: IPrivateRouteProps = {
    path: ROUTES.BASE,
    component: Main,
    redirectPath: ROUTES.LOGIN,
  }

  return (
    <div className={classes['app-wrapper']}>
      <Switch>
        <Route strict exact path={ROUTES.LOGIN} component={Login} />
        <ProtectedRoute {...IPrivateRouteProps} />
      </Switch>
    </div>
  )
}

export default withRouter(App)
